import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import configureDcmio from "../utils/configureDCMIO";
import Store from "../utils/Store";
import Toast from "./Toast";
import React from "react";
import { useTranslation } from "react-i18next";
export default function ConfigureDCMIO() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("p", {
    className: "text-[14px]"
  }, t("enterprise_users"), ",", " ", /*#__PURE__*/React.createElement("span", {
    className: "text-teal-400 hover:text-teal-500 dark:text-teal-200 dark:hover:text-teal-300 cursor-pointer",
    onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return configureDcmio();
            case 3:
              Toast.success(t("toast.configured_successfully"));
              Store.update(function (s) {
                s.isConnectModalityOpen = false;
              });
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              Toast.error(t("error_key"));
            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }))
  }, t("configure_dcmio")));
}